import { useContext, useState } from 'react';
import Cards from '../../../assets/images/carde.png'

// @styles 
import './styles.scss'
import '../small-switch/styles.scss'
import Context from 'context/appContext';
import { useEffect } from 'react';
import { getUrl } from 'utils/utils';
import LoadingProcedure from 'components/loading-procedure';

export default function CardsAdditional({ info, form, openNotification }) {
    const [defaultClass, setDefaultClass] = useState('active-btn-right');
    const [isClassAux, setIsClassAux] = useState({ TEV: false, FHM: false });
    const [loadingComponent, setLoadingComponent] = useState(false);
    const data = info;
    const keyAdditionals = 'aditionals';

    const { dataForm: { formResponses }, customRequest, isActiveAditionals, setDisabledButtonContinue, setReturnButton, setIsActiveAditionals, setPriceToShow, formStatus: { steps, currentStep, currentQuestion, numberQuestionsStep, isGoToBack } } = useContext(Context)

    useEffect(() => {
        const field = formResponses.find(x => x.key === keyAdditionals);
        const active = field && field.active
        const obj = field && field.activeAux
        active && setIsActiveAditionals(active);
        obj && setIsClassAux(obj);
    }, []);

    const serviceCalculator = async () => {
        setLoadingComponent(true);
        setDisabledButtonContinue(true);
        setReturnButton(false);
        const valPrimary = steps[currentStep] && steps[currentStep].questions[currentQuestion] && steps[currentStep].questions[currentQuestion].primary;
        const opt = valPrimary && valPrimary.opciones_servicio_segundo_plano
            ? valPrimary.opciones_servicio_segundo_plano
            : '';
        const opciones_servicio = opt && getUrl(opt, formResponses, 'calculator', form);
        await customRequest(opciones_servicio.url, opciones_servicio.header, opciones_servicio.method, null).then((res) => {
            res && res.data && res.data.totalPremium && setPriceToShow(res.data.totalPremium);
        })
            .catch(async (error) => {
                throw new Error(error)
            })
        setLoadingComponent(false);
        setDisabledButtonContinue(false);
        setReturnButton(true);
    }

    useEffect(() => {
        const copyIsClassActive = JSON.parse(JSON.stringify(isActiveAditionals));
        let obj = { key: keyAdditionals, active: copyIsClassActive, activeAux: isClassAux };
        const indexField = formResponses.findIndex(x => x.key === keyAdditionals);
        indexField !== -1 ? formResponses[indexField] = obj : formResponses.push(obj);
    }, [isActiveAditionals]);

    const onClick = async (index, active) => {
        const indexField = formResponses.findIndex(x => x.key === keyAdditionals);
        let copyIsClassActive = JSON.parse(JSON.stringify(isActiveAditionals));
        copyIsClassActive = { ...copyIsClassActive, [index]: isClassAux[index] };
        const obj = { key: keyAdditionals, active: copyIsClassActive, activeAux: { ...copyIsClassActive, [index]: !isClassAux[index] } };
        indexField !== -1 ? formResponses[indexField] = obj : formResponses.push(obj);
        setIsActiveAditionals({ ...isActiveAditionals, [index]: isClassAux[index] });
        setIsClassAux({ ...isClassAux, [index]: !isClassAux[index] });
        setDefaultClass('active-btn-right');
        await serviceCalculator();
        openNotification(active);

    };
    return (<>
        {loadingComponent && (<LoadingProcedure message={'Cotizando'} />)}
        <div className='coverages-economy additional-card'>
            <div className='coverages-economy__title'>
                <p>{data && data.title}</p>
            </div>
            <div className='coverages-economy__content'>
                {data && data.components.map((card) => {
                    const index = card && card.key;
                    return card && card.type === 'radio' ? <div className='coverages-economy__content-additionalcards'>
                        <div className='coverages-economy__content-additionalcards__item'>
                            <img className='coverages-economy__content-additionalcards__item-img' src={card && card.properties && card.properties.img ? card.properties.img : Cards} alt={card?.label} />
                            <div className={`coverages-economy__content-additionalcards__item-text ${card.values[0].label == 'Incluida' ? 'padding-top' : ''}`}>
                                <strong>{card && card.label}</strong>
                                <p>{card && card.description}</p>
                            </div>
                            <div className='coverages-economy__content-additionalcards__item-actions'>
                                {card && card.values && card.type === 'radio' && card.values.length === 1 ? (
                                    <div className='coverages-economy__content-additionalcards__item-actions-included'>
                                        {card.values[0] && card.values[0].label ? card.values[0].label.toUpperCase() : 'INCLUIDA'}
                                    </div>) :
                                    <div className='smallswitch__container' id={index}>
                                        <div className='smallswitch__container__buttons' id={index}>
                                            <button className={`smallswitch__container__buttons-btn ${!isActiveAditionals[index] ? 'active-btn-left' : ''}`}
                                                disabled={!isActiveAditionals[index]}
                                                onClick={() => onClick(index, false)}>
                                                <span>No</span>
                                            </button>
                                            <button className={`smallswitch__container__buttons-btn ${isActiveAditionals[index] && defaultClass}`}
                                                disabled={isActiveAditionals[index]}
                                                onClick={() => onClick(index, true)}>
                                                <span>Si</span>
                                            </button>
                                        </div>
                                    </div>
                                }
                            </div>
                        </div>
                    </div> :
                        <div className='coverages-economy__content-additionaltext'>
                            <div>
                                <td dangerouslySetInnerHTML={{ __html: card && card.html ? card.html : "" }} />
                            </div>
                        </div>
                })}
            </div>
        </div>
    </>
    )
}